import { Component, Input, OnInit } from '@angular/core';

import { CustomFieldTypes } from 'src/app/core/api/models';
import { AppCustomFieldSelectSearch } from 'src/app/core/types/app-custom-field-select-search.type';
import { OrganizationCustomFieldsService } from '../../../core/api/services/organization-custom-fields.service';
import { BaseSelectSearch } from './base/base-select-search.component';
import { BaseSelectSearchModule } from './base/base-select.search.module';

@Component({
    selector: 'organization-custom-field-select-search',
    templateUrl: './base/base-select-search-template.html',
    imports: [BaseSelectSearchModule]
})
export class OrganizationCustomFieldSelectSearchComponent
  extends BaseSelectSearch
  implements OnInit
{
  @Input('type') input_type: AppCustomFieldSelectSearch = 'id';
  @Input('customFieldType') input_customFieldType: CustomFieldTypes;

  constructor(protected currentService: OrganizationCustomFieldsService) {
    super();
  }

  initConfig() {
    this.optionValue = 'id';
    this.optionTitle = 'nameFa';

    if (this.input_type == 'nameEn') this.optionValue = 'nameEn';

    if (!this.label) this.label = 'common.customFields';
  }

  getItemsApi() {
    this.currentService
      .organizationCustomFieldsGetOrganizationCustomFieldsDropDown(
        this.input_customFieldType
          ? { CustomFieldTypes: this.input_customFieldType }
          : {}
      )
      .pipe(this.basePipeOperators())
      .subscribe({
        next: (items) => {
          this.items = items?.data;
          this.setDefaultValue();
        },
        error: (error) => {
          this.emitError();
        },
      });
  }
}
